<template>
  <v-container width="100%" class="px-0 mx-0 pt-3" fluid>
    <h1 class="text-center mt-10">Отзывы наших клиентов:</h1>
    <v-row>
      <v-col
          v-for="review in reviews"
          :key="review.name"
          :cols="cols"
          max-height="500px"
          class="my-10"
      >
        <v-card
            class="mx-0 my-10 rounded-xl"
            color=""
            height="100%"
            elevation="5"
          >
            <v-card-title>
              <v-icon
                left
                class="ml-2"
                size="30"
              >
                $vuetify.icons.vk
              </v-icon>
<!--              <span class="">VK</span>-->
            </v-card-title>

            <v-card-text class="px-5">
              {{ review.text }}
            </v-card-text>
            <v-card-actions class="py-0 mx-0 card-actions">
              <v-list-item>
                <v-list-item-avatar color="grey darken-3">
                  <v-img
                    class="elevation-6"
                    :src="require('../assets/' + review.id + '.jpeg')"
                  ></v-img>
                </v-list-item-avatar>

                <v-list-item-content>

                  <v-btn
                      :href=review.link
                      target="_blank"
                      class="align-self-start subtitle-1 text-capitalize"
                      :ripple="false"
                      plain
                  >
                  <v-list-item-title>{{ review.name }}</v-list-item-title>

                  </v-btn>
                </v-list-item-content>

              </v-list-item>
            </v-card-actions>

          </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Reviews.vue",
  data() {
    return {
      reviews: [
        {
          name: "Дмитрий Ёлгин",
          text: "Ваша статистика по MK — это просто бомба. Если знаешь и умеешь разбираться в алгоритмах, можно находить интересные закономерности. Даже если не умеешь — это отличное место для изучения аналитики. Я использую сервис для глубокой работы с данными, и он даёт огромные возможности. Структура статистики чёткая и понятная, что делает работу удобной и эффективной.",
          link: "https://vk.com/id410179001",
          id: "1",
        },
        {
          name: "Михаил Курочкин",
          text: "С создателем и идейным вдохновителем сервиса я общаюсь с 2017 года, и за всё время не было ни одного повода для недовольства. Он всегда чётко отвечает на запросы пользователей и делает сервис удобнее. Развитие продолжается, и это здорово!",
          link: "https://vk.com/m21shka",
          id: "2",
        },

        {
          name: "Артур Абрамов",
          text: "Очень удобная и проработанная статистика. Большой выбор фильтров позволяет рассматривать матчи с разных сторон, что помогает принимать более обоснованные решения. Нравится, что создатели оперативно добавляют полезные улучшения. Лично мне такой инструмент очень помогает.",
          link: "https://vk.com/id57129664",
          id: "3",
        },
        {
          name: "Аслан Беккалиев",
          text: "Добрый день! Хочу оставить отзыв, потому что сервис действительно мощный: есть много фильтров, благодаря которым можно анализировать динамику матчей под разными углами. Это помогает замечать детали, которые раньше ускользали. Удобный адаптивный интерфейс — 90% работы можно делать прямо с телефона, что сильно экономит время. Рекомендую!",
          link: "https://vk.com/id27920229",
          id: "4",
        },
        {
          name: "Андрей Познанский",  
          text: "Иногда хочется вспомнить игру и проанализировать несколько матчей, поэтому периодически возвращаюсь к сервису. Когда спросил знакомого, кто в этом разбирается, он сразу посоветовал Universtat. Действительно удобный интерфейс, куча фильтров, быстрая реакция поддержки. Сразу взял обучающий урок — всё объяснили, теперь использую инструмент на полную!",
          link: "https://vk.com/anubis849",
          id: "5",
        },

        {
          name: "Иван Апёнышев",
          text: "Universtat — один из самых удобных сервисов статистики! Гибкость фильтров позволяет глубже изучать матчи, что делает работу с данными гораздо интереснее. Мне нравится такой формат аналитики — каждый день можно открывать что-то новое и прокачивать навыки системного мышления. Пользуюсь регулярно и доволен результатом!",
          link: "https://vk.com/erudirone",
          id: "6",
        }
      ]
    }
  },
  computed: {
    cols() {
      const points = {
        "xs": 12,
        "sm": 12,
        "md": 6,
        "lg": 4,
        "xl": 4
      }
      return points[this.$vuetify.breakpoint.name]
    },
  }
}
</script>

<style scoped>

.card-actions {
  position: absolute;
  margin-bottom: 10px;
  bottom: 0;
}

.underline {
  text-decoration: underline !important;
  /* text-underline-offset: 2px; */
  text-underline-position: under left;
  /* text-underline-width: 2px; */
  text-decoration-thickness: 1px;
  text-decoration-color: #000;
  /* background: #cccccc; */
}
</style>